<template>
	<div class="inputFieldContainer">
		<!--	Wrapped the Input with a clientOnly element to remove hydration console logs, not sure why this is happening	-->
		<ClientOnly>
			<label
				:for="id"
				class="inputFieldLabel"
				:class="labelColor"
				>{{ label }}
				<FormRequiredAsterisk :required="required" />
			</label>
			<input
				:id="id"
				:autocomplete="autocomplete"
				type="text"
				:placeholder="placeholder"
				v-model="value"
				class="inputField"
				:class="{ inputFieldError: hasError }"
				:disabled="disabled"
				@blur="blur"
				@change="changed" />
			<label
				:for="id"
				v-if="hasError && errorMessage"
				class="inputFieldErrorLabel"
				>{{ errorMessage }}</label
			>
		</ClientOnly>
	</div>
</template>

<script setup>
	const runtimeConfig = useRuntimeConfig()

	const { id, initialValue } = defineProps({
		id: {
			type: String,
			default: "inputField",
		},
		label: {
			type: String,
			default: "Field Label",
		},
		labelColor: {
			type: String,
			default: "text-primary",
		},
		placeholder: {
			type: String,
			default: "",
		},
		required: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		hasError: {
			type: Boolean,
			default: false,
		},
		errorMessage: {
			type: String,
			default: "",
		},
		initialValue: {
			type: String,
			default: "",
		},
	})

	const autocomplete = runtimeConfig.public.IS_KIOSK_APP ? "dsadsa" : ""

	const emits = defineEmits(["changed", "blur"])
	const value = ref(initialValue)

	const changed = () => {
		emits("changed", { id: id, value: value.value })
	}

	const blur = () => {
		emits("blur", { id: id, value: value.value })
	}
</script>

<style scoped></style>
